"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Accordion_1 = __importDefault(require("./Accordion/Accordion"));
var Banner_1 = __importDefault(require("../../components/Banner/Banner"));
var support_banner_png_1 = __importDefault(require("../../../images/support_banner.png"));
var AppFooter_1 = __importDefault(require("../../components/AppFooter/AppFooter"));
var SupportPage = function () {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: 'support' },
            react_1.default.createElement(Banner_1.default, { image: support_banner_png_1.default, textSmall: 'SUPPORT.TEXTSMALL', textBig: 'SUPPORT.TEXTBIG' }),
            react_1.default.createElement("div", { className: "container-1024" },
                react_1.default.createElement(Accordion_1.default, null))),
        react_1.default.createElement(AppFooter_1.default, { layout: 'HOME' })));
};
exports.default = SupportPage;
